// `PlatformLogo` binding for the three surfaces that draw a provider mark (tile, auth card, reauth
// modal).
//
// It exists because of one type rule and one design rule. `resolveStaticPlatformLogo` returns
// `string | undefined`, and the repo compiles with `exactOptionalPropertyTypes`, so binding that
// straight to the optional `src` prop is a type error rather than a no-op — the resolved value has
// to be spread in only when present. And `PlatformLogo` owns no key space: it renders the `src` it is
// handed and falls back to a question-mark glyph otherwise, which is why the lookup belongs to the
// caller. Three call sites, one helper — the same shape module 29 uses
// (`HealthCheckDetailTable.vue:44-54`).

import { resolveStaticPlatformLogo, type PlatformLogoProps } from '@/shared/ui'

/**
 * @param logoKey a key from ORP-19909's 47-entry catalog (`IntegrationProvider.logo`).
 * @param alt localized accessible name; the provider's translated name at every call site.
 */
export function platformLogoProps(logoKey: string, size: number, alt: string): PlatformLogoProps {
  const src = resolveStaticPlatformLogo(logoKey)
  return { platform: logoKey, channel: logoKey, size, alt, ...(src ? { src } : {}) }
}
